'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _set = require('./set');

var _set2 = _interopRequireDefault(_set);

var _pipeWith = require('./util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'swap',
    all: function all(keyA, keyB) {
        return function (value) {
            return (0, _pipeWith2.default)(value, (0, _set2.default)(keyA, (0, _get2.default)(keyB)(value)), (0, _set2.default)(keyB, (0, _get2.default)(keyA)(value)));
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/swap.js
// module id = 271
// module chunks = 35783957827783